import axios from "axios";
import { isImageOrVideo } from "../utils/isImageOrVideo";

const url = "https://backend.girnarsoft.com/api/v1/staging/";

const api = axios.create({
  baseURL: url,
});

export const addUpdateApi = async ({ data, type, method, id }) => {
  const endpoints = {
    article: {
      post: "article/addArticle",
      patch: `article/updateArticleById/${id}`,
    },
    technology: {
      post: "technology/addTechnology",
      patch: `technology/updateTechnologyById/${id}`,
    },
    industry: {
      post: "industries/addIndustry",
      patch: `industries/updateIndustryById/${id}`,
    },
    caseStudy: {
      post: "caseStudy/addCaseStudy",
      patch: `caseStudy/updateCaseStudyById/${id}`,
    },
    solution: {
      post: "solution/addSolution",
      patch: `solution/updateSolutionById/${id}`,
    },
    products: {
      post: "product/addProduct",
      patch: `product/updateProductById/${id}`,
    },
    compliance: {
      post: "compliance/createCompliance",
      patch: `compliance/updateComplianceById/${id}`,
    },
    career: {
      post: "",
      patch: `career/updateCareerById/${id}`,
    },
    about: {
      post: "",
      patch: `about/updateAboutById/${id}`,
    },
    service: {
      post: "",
      patch: `service/updateServiceById/${id}`,
    },
    technologyPage: {
      post: "",
      patch: `technologyPage/updateTechnologyPageById/${id}`,
    },
    solutionPage: {
      post: "",
      patch: `solutionPage/updateSolutionPageById/${id}`,
    },
    industryPage: {
      post: "",
      patch: `industriesPage/updateIndustriesPageById/${id}`,
    },
    productsPage: {
      post: "",
      patch: `productPage/updateProductPageById/${id}`,
    },
    settingsPage: {
      post: "",
      put: `settings/updateSettingsById/${id}`,
    },
  };

  console.log(type);
  console.log(method);

  const url = endpoints[type]?.[method];

  if (!url) {
    throw new Error("Invalid type or method");
  }

  console.log(url);
  console.log(method);
  console.log(data);

  try {
    const response = await api({
      url,
      method,
      data,
    });
    return response;
  } catch (err) {
    console.error("API call failed", err);
    throw err;
  }
};

export const getAllApi = async (type) => {
  const endpoints = {
    article: "article/getAllArticles",
    technology: "technology/getAllTechnology",
    industry: "industries/getAllIndustries",
    caseStudy: "caseStudy/getAllCaseStudy",
    solution: "solution/getAllSolutions",
    products: "product/getAllProduct",
    compliance: "compliance/getAllCompliance",
    career: "career/getAllCareers",
    about: "about/getAllAbouts",
    service: "service/getAllServices",
    technologyPage: "technologyPage/getAllTechnologyPage",
    solutionPage: "solutionPage/getAllSolutionPage",
    industryPage: "industriesPage/getAllIndustriesPage",
    productsPage: "productPage/getAllProductPage",
    settings: "settings/getSettings",
  };

  const url = endpoints[type];

  if (!url) {
    throw new Error("Invalid Type");
  }

  console.log(url);

  try {
    const res = await api({
      url,
      method: "get",
    });
    console.log(res);
    return res;
  } catch (err) {
    throw err;
  }
};

export const uploadImageApi = async (file, type = "article") => {
  const endpoints = {
    article: "article/uploadBlogImage",
    technology: "technology/uploadImage",
    industry: "industries/uploadBlogImage",
    caseStudy: "caseStudy/uploadImage",
    solution: "solution/uploadImage",
  };

  const url = endpoints[type];

  if (!url) {
    throw new Error("Invalid Type");
  }

  try {
    const formdata = new FormData();
    formdata.append("file", file);

    const res = await api({
      url:
        isImageOrVideo(file) === "image"
          ? "https://backend.girnarsoft.com/api/v1/staging/uploadImage"
          : "https://backend.girnarsoft.com/api/v1/staging/article/uploadFile",
      method: "post",
      data: formdata,
    });

    console.log(res);
    return res;
  } catch (err) {
    console.log(err);
    throw err;
  }
};

export const deleteByIdApi = async (type, id) => {
  const endpoints = {
    article: `article/deleteArticleById/${id}`,
    technology: `technology/deleteTechnologyById/${id}`,
    industry: `industries/deleteIndustryById/${id}`,
    caseStudy: `caseStudy/deleteCaseStudyById/${id}`,
    solution: `solution/deleteSolutionById/${id}`,
    compliance: `compliance/deleteComplianceById/${id}`,
    products: `product/deleteProductById/${id}`,
    category: `home/delete/?id=${id}`,
  };

  const url = endpoints[type];

  if (!url) {
    throw new Error("Invalid Type");
  }

  try {
    const res = await api({
      url,
      method: "delete",
    });
    return res;
  } catch (err) {
    throw err;
  }
};

export const getByIdApi = async (type, id) => {
  const endpoints = {
    article: `article/getArticleById/${id}`,
    technology: `technology/getTechnologyById/${id}`,
    industry: `industries/getIndustryById/${id}`,
    caseStudy: `caseStudy/getCaseStudyById/${id}`,
    solution: `solution/getSolutionsById/${id}`,
    products: `product/getProductById/${id}`,
    compliance: `compliance/getComplianceById/${id}`,
  };

  const url = endpoints[type];

  if (!url) {
    throw new Error("Invalid type");
  }

  try {
    const res = await api({
      url,
      method: "get",
    });
    return res;
  } catch (err) {
    console.log(err);
    throw err;
  }
};

// HOME START //
export const getHomeData = async () => {
  const res = await api({
    url: "home/getAllDetails",
    method: "get",
  });
  return res;
};

export const updateHomeData = async (data, id) => {
  const res = await api({
    url: "home/updateHomePage/" + id,
    method: "patch",
    data: data,
  });
  return res;
};
// HOME ENDS  //

// Staff Augmentation //
export const getStaffAugmentation = async () => {
  const res = await api({
    url: "staff/getAllStaffAgumentationDetails",
    method: "get",
  });
  return res;
};

export const updateStaffAugmentation = async (data, id) => {
  const res = await api({
    url: "staff/updateStaffAgumentation/" + id,
    method: "patch",
    data: data,
  });
  return res;
};
// Staff Augmentation end //

export const getDedicatedTeams = async () => {
  const res = await api({
    url: "dedicatedTeam/getAllDedicatedTeam",
    method: "get",
  });
  return res;
};

export const updateDedicatedTeams = async (data, id) => {
  const res = await api({
    url: "dedicatedTeam/updateDedicatedTeam/" + id,
    method: "patch",
    data: data,
  });
  return res;
};

export const getSoftwareOutsourcing = async () => {
  const res = await api({
    url: "softwareOutsourcing/getAllSoftwareSourcing",
    method: "get",
  });
  return res;
};

export const updateSoftwareOutsourcing = async (data, id) => {
  const res = await api({
    url: "softwareOutsourcing/updateSoftwareSourcingById/" + id,
    method: "patch",
    data: data,
  });
  return res;
};

export const getJobs = async () => {
  const res = await api({
    url: "job/getAllJobs",
    method: "get",
  });
  return res;
};

export const createJob = async (data) => {
  const res = await api({
    url: "job/addJob",
    method: "post",
    data: data,
  });
  return res;
};

export const getJobById = async (id) => {
  const res = await api({
    url: "job/getJobById/" + id,
    method: "get",
  });
  return res;
};

export const updateJobById = async (data, id) => {
  const res = await api({
    url: "job/updateJobById/" + id,
    method: "patch",
    data: data,
  });

  return res;
};

export const delJobById = async (id) => {
  const res = await api({
    url: "job/deleteJobById/" + id,
    method: "delete",
  });

  return res;
};

export const getCategoriesApi = async (id) => {
  const res = await api({
    url: "home/get-all-category",
    method: "get",
  });

  return res;
};
